// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Position-module--cls1--rVhNN","cls2":"styles-Position-module--cls2--Zqvnm styles-Position-module--cls1--rVhNN"};